module.exports = __webpack_public_path__ + "img/trawenagh_1.9f615efb.webp";